import { render, staticRenderFns } from "./audience.vue?vue&type=template&id=27c4522a"
import script from "./audience.vue?vue&type=script&lang=js"
export * from "./audience.vue?vue&type=script&lang=js"
import style0 from "./audience.vue?vue&type=style&index=0&id=27c4522a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports